import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from '../common/common.service';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS } from '../../http/api-end-points';

@Injectable({
    providedIn: 'root'
})
export class ChatBotService {

    private modalState = new BehaviorSubject<{ trigger: string, flag: boolean; }>({ trigger: '', flag: false });

    // Observable for components to subscribe
    modalState$ = this.modalState.asObservable();

    constructor(private _common: CommonService) {

    }

    open(trigger: string) {
        this.modalState.next({ trigger: trigger, flag: true });
    }

    close(trigger: string) {
        this.modalState.next({ trigger: trigger, flag: false });
    }



    sendMessageToBot(body: any) {
        return this._common.performPostRequest(environment.workspaceApiUrl + API_ENDPOINTS.AI_CHATBOT.BUGS, { payload: JSON.stringify(body) });
    }

    sendMessageToSurvayBot(body: any) {
        return this._common.performPostRequest(environment.workspaceApiUrl + API_ENDPOINTS.AI_CHATBOT.SURVAY, { payload: JSON.stringify(body) });
    }

    sendMessageToCrashesBot(body: any) {
        return this._common.performPostRequest(environment.workspaceApiUrl + API_ENDPOINTS.AI_CHATBOT.CRASHES, { payload: JSON.stringify(body) });
    }

    createSessionCrash(body: any) {
        return this._common.performPostRequest(environment.workspaceApiUrl + API_ENDPOINTS.AI_CHATBOT.CRASHES_SESSION_CREATE, { payload: JSON.stringify(body) });
    }
}
